<div class="main_content">
    <div class="container">
        <div class="error_content">
            <h1>{{'ERROR.ERROR_404' | translate}}</h1>
            <h2>{{'ERROR.ERROR_DESCRIPTION' | translate}}</h2>
        </div>
    </div>
</div>